import React from 'react';
import {
  NumberInput, Create, SimpleForm,
  TextInput, ReferenceInput, SelectInput
} from 'react-admin';

export default (props) => {
  return (
    <Create title="Create a Wind Turbine" {...props} mutationMode="pessimistic">
      <SimpleForm>
        <TextInput source="name" />
        <TextInput
          source="identifier"
          label="Serial Number (Identifier)"
          helperText="Cod numeric simplu (ex. 0001, 0002, 00015...). Trebuie să fie identic cu username-ul MQTT configurat pe placă - dacă nu coincide exact, turbina nu va primi niciodată date."
        />

        <TextInput source="latitude" />
        <TextInput source="longitude" />

        <NumberInput source="maxPower" defaultValue={62} />

        <TextInput
          source="email"
          label="Email notificări erori"
          helperText="Adresa la care se trimit erorile turbinei, din pagina de informații (Orbital)."
        />

        <ReferenceInput
          label="Type"
          reference="turbineTypes"
          source="type.id"
          perPage={1000}
        >
          <SelectInput optionText="name"/>
        </ReferenceInput>

        <ReferenceInput
          label="Farm"
          reference="farms"
          source="farm.id"
          perPage={1000}
        >
          <SelectInput optionText="name"/>
        </ReferenceInput>
      </SimpleForm>
    </Create>
  );
}
